export const quote = {
  // Page Title
  pageTitle: "Vraag een",
  pageTitleHighlight: "Gratis Offerte",
  pageDescription: "Beschrijf uw project in enkele stappen en ontvang een gepersonaliseerde schatting",
  
  // Progress
  step: "Stap",
  of: "van",
  completed: "% voltooid",
  securityNote: "Uw gegevens zijn beveiligd en vertrouwelijk",
  
  // Step 1: Work Type
  step1Title: "Welk type werken wenst u uit te voeren?",
  step1Description: "Selecteer een of meerdere types werken",
  workTypes: {
    interiorRenovation: "Renovatie interieur",
    bathroom: "Badkamer",
    kitchen: "Keuken",
    basement: "Kelder",
    atticConversion: "Zolderinrichting",
    extension: "Uitbreiding",
    facade: "Gevel",
    roofing: "Dakwerken",
    flooring: "Vloer",
    painting: "Schilderwerken",
    electricity: "Elektriciteit",
    plumbing: "Sanitair",
    carpentry: "Schrijnwerk",
    insulation: "Isolatie",
    other: "Andere"
  },
  selectAtLeastOne: "Gelieve minstens één type werken te selecteren",
  
  // Step 2: Housing Type
  step2Title: "Wat is het type woning?",
  step2Description: "Kies het type van uw eigendom",
  housingTypes: {
    apartment: "Appartement",
    house: "Huis",
    studio: "Studio",
    duplex: "Duplex",
    loft: "Loft",
    commercial: "Handelspand",
    office: "Kantoor"
  },
  selectHousingType: "Gelieve een type woning te selecteren",
  
  // Step 3: Location
  step3Title: "Waar bevindt het project zich?",
  step3Description: "Vul de postcode en gemeente in",
  postalCode: "Postcode",
  postalCodePlaceholder: "Bijv: 1000",
  city: "Gemeente",
  cityPlaceholder: "Bijv: Brussel",
  selectCity: "Selecteer een gemeente",
  invalidPostalCode: "Ongeldige postcode",
  fillBothFields: "Gelieve beide velden in te vullen",
  
  // Step 4: Project Details
  step4Title: "Projectdetails",
  step4Description: "Vertel ons over uw project",
  projectDescription: "Projectomschrijving",
  descriptionPlaceholder: "Beschrijf uw project in detail: gewenste werken, oppervlakte, voorkeuren...",
  estimatedBudget: "Geschat budget",
  budgetPlaceholder: "Bijv: 10.000 - 15.000 €",
  desiredDeadline: "Gewenste termijn",
  deadlinePlaceholder: "Bijv: Binnen 3 maanden",
  photos: "Foto's (optioneel)",
  photosNote: "Als u foto's heeft, kunt u deze later per e-mail versturen",
  photosPlaceholder: "Wij vragen later om foto's indien nodig",
  fillDescription: "Gelieve de projectomschrijving in te vullen",
  
  // Step 5: Contact
  step5Title: "Uw contactgegevens",
  step5Description: "Laatste stap! Hoe kunnen wij u bereiken?",
  fullName: "Volledige naam",
  namePlaceholder: "Bijv: Jan Janssens",
  phone: "Telefoon",
  phonePlaceholder: "Bijv: +32 123 45 67 89",
  email: "E-mail",
  emailPlaceholder: "Bijv: jan.janssens@email.com",
  dataProtection: "Uw gegevens zijn beschermd",
  dataProtectionText: "Wij gebruiken uw gegevens enkel om contact met u op te nemen over uw offerteaanvraag.",
  required: "*",
  
  // Buttons
  next: "Volgende",
  previous: "Vorige",
  back: "Terug",
  submit: "Mijn offerte ontvangen",
  submitting: "Verzenden...",
  
  // Success
  successTitle: "Bedankt!",
  successSubtitle: "Uw aanvraag is succesvol ontvangen",
  successMessage: "Wij contacteren u zo spoedig mogelijk om uw project te bespreken en u een gedetailleerde offerte te bezorgen.",
  successNextSteps: "Volgende stappen:",
  successStep1: "Wij bekijken uw aanvraag zorgvuldig",
  successStep2: "Wij contacteren u binnen 24-48 uur",
  successStep3: "Wij maken een afspraak voor een plaatsbezoek indien nodig",
  successStep4: "U ontvangt een gedetailleerde en gepersonaliseerde offerte",
  backToHome: "Terug naar home",
  
  // Error messages
  errorSubmitting: "Er is een fout opgetreden. Gelieve opnieuw te proberen.",
};